import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  return <section className="py-20 px-6 bg-sage" data-id="element-159">
      <div className="max-w-5xl mx-auto" data-id="element-160">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-161">
          {/* Para quién ES */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-8 shadow-lg border-t-8 border-green-500" data-id="element-162">
            <h3 className="text-2xl font-serif font-bold text-forest mb-6 text-center" data-id="element-163">
              ¿Para quién SÍ es esto?
            </h3>
            <ul className="space-y-4" data-id="element-164">
              <li className="flex gap-3 items-start" data-id="element-165">
                <div className="bg-green-100 p-1 rounded-full mt-1" data-id="element-166">
                  <Check className="w-5 h-5 text-green-600" data-id="element-167" />
                </div>
                <span className="text-brown font-medium" data-id="element-168">
                  Para madres que trabajan y quieren recuperar sus noches.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-169">
                <div className="bg-green-100 p-1 rounded-full mt-1" data-id="element-170">
                  <Check className="w-5 h-5 text-green-600" data-id="element-171" />
                </div>
                <span className="text-brown font-medium" data-id="element-172">
                  Para quienes necesitan bajar el gasto en delivery y súper.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-173">
                <div className="bg-green-100 p-1 rounded-full mt-1" data-id="element-174">
                  <Check className="w-5 h-5 text-green-600" data-id="element-175" />
                </div>
                <span className="text-brown font-medium" data-id="element-176">
                  Para las que quieren comer sano pero odian lavar platos todos
                  los días.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Para quién NO ES */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-2xl p-8 shadow-lg border-t-8 border-red-400 opacity-90" data-id="element-177">
            <h3 className="text-2xl font-serif font-bold text-gray-600 mb-6 text-center" data-id="element-178">
              ¿Para quién NO es?
            </h3>
            <ul className="space-y-4" data-id="element-179">
              <li className="flex gap-3 items-start" data-id="element-180">
                <div className="bg-red-100 p-1 rounded-full mt-1" data-id="element-181">
                  <X className="w-5 h-5 text-red-500" data-id="element-182" />
                </div>
                <span className="text-gray-600" data-id="element-183">
                  Para gente que tiene 3 horas diarias para cocinar platos
                  gourmet.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-184">
                <div className="bg-red-100 p-1 rounded-full mt-1" data-id="element-185">
                  <X className="w-5 h-5 text-red-500" data-id="element-186" />
                </div>
                <span className="text-gray-600" data-id="element-187">
                  Para quienes no tienen freezer o heladera con congelador.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}